<template>
  <el-dialog :visible.sync="visible" @close="closeDialog" class="table" append-to-body :show-close="false">
    <template #title>
      <DialogCloseBtn @close="closeDialog"/>
      费用明细
    </template>
    <el-table :data="tableData" class="table">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column label="网站名称" prop="webType" class="font-bold"></el-table-column>
      <el-table-column label="下载费用" prop="price" class="font-red"></el-table-column>
      <el-table-column label="选图网址（可能需要翻墙）">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.enUrl != ''"
            type="success"
            size="small"
            @click="linkOverseas(scope.row)"
          >点击访问</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column width="180" label="国内代理商（无需翻墙）">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.zhUrl != ''"
            type="primary"
            size="small"
            @click="linkDomestic(scope.row)"
          >访问中文站</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="totalDataNum"
    ></el-pagination>
  </el-dialog>
</template>

<script>
import {chargesList} from '../../../api/downLoad';
import DialogCloseBtn from '@/components/DialogCloseBtn.vue';
export default {
  props: ["dialogVisible"],
  components:{DialogCloseBtn},
  watch: {
    dialogVisible: {
      handler(val) {
        this.visible = val;
        if (val) this.getTableDatas();
      },
      deep: true
    }
  },
  data() {
    return {
      visible: false,
      // tableData: [],
      currentPage: 1,
      pageSize: 10,
      allData: [],
    };
  },
  computed:{
    tableData(){
      return this.allData.length? this.allData[this.currentPage-1]: [];
    },
    totalDataNum(){
      let sum = 0;
      this.allData.forEach(page => {
          sum += page.length;
      });
      return sum;
    }
  },
  methods: {
    handlePages(data){
      const array = [];
      let startIndex = 0;
      const pageSize = 10;
      function loop() {
        const sliced = data.slice(startIndex, startIndex + pageSize);
        if (sliced.length) {
          array.push(sliced);
          startIndex += pageSize;
          loop();
        }
      }

      loop();
      return array;
    },
    getTableDatas() {
      chargesList().then((result) => {
        //hide "SS/Hai_V2"
        // result.map((item)=>{
        //   if(item.webType === 'SS/Hai_V2'){
        //     item.enUrl = '';
        //   }
        //   return item;
        // });
        // const newObject = {
        //     "webType": "默认_V2",
        //     "price": 1.90,
        //     "enUrl": "https://www.shutterstock.com/",
        //     "zhUrl": "https://www.shutterstock.com/"
        // };  // 要添加的对象
        // this.result.splice(0, 0, newObject);
        // console.log("dddddddd"+this.result.size)

        const newObject = {
            "webType": "默认_V2",
            "price": 1.90,
            "enUrl": "https://www.shutterstock.com/",
            "zhUrl": "https://www.shutterstock.com/"
        };  // 要添加的对象
        result.push(newObject)
        this.allData = this.handlePages(result);
      }).catch((error) => {
        console.log(error);
      })
    },
    linkOverseas(row) {
      console.log('ddddd:',row);
      window.open(row.enUrl);
    },
    linkDomestic(row) {
      window.open(row.zhUrl);
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    }
  }
};
</script>
